/**
 * @generated SignedSource<<caad2e6c77a1cea72076eb9b8766043d>>
 * @relayHash 177e078b14a8fc5099a49488fa5b9307
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8bf72c450e072a22595a404fab60f628cddb96aafcffc4a1c819473dec459b1

import type { ConcreteRequest } from 'relay-runtime';
export type useLabelsSelectPropsSSRLabelsQuery$variables = {
  contentId: string;
};
export type useLabelsSelectPropsSSRLabelsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly labels: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly __typename: "Label";
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly id: string | null;
      } | null;
      readonly status: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type useLabelsSelectPropsSSRLabelsQuery = {
  response: useLabelsSelectPropsSSRLabelsQuery$data;
  variables: useLabelsSelectPropsSSRLabelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": {
                  "direction": "ASCENDING",
                  "sortField": "LABELLING_CREATIONDATE"
                }
              }
            ],
            "concreteType": "PaginatedLabelList",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "label"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "prefix"
                  }
                ]
              }
            ],
            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelsSelectPropsSSRLabelsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelsSelectPropsSSRLabelsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "177e078b14a8fc5099a49488fa5b9307",
    "id": "d8bf72c450e072a22595a404fab60f628cddb96aafcffc4a1c819473dec459b1",
    "metadata": {},
    "name": "useLabelsSelectPropsSSRLabelsQuery",
    "operationKind": "query",
    "text": "query useLabelsSelectPropsSSRLabelsQuery($contentId:ID!){content(id:$contentId){nodes{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
  }
};
})();

(node as any).hash = "86d7b3b1b2e1a3451db569340ef97a6a";

export default node;
